<nz-layout>
    <nz-header>
    </nz-header>
    <nz-content>
        <div fxLayout="row" fxLayoutGap="5%">
            <div fxLayout="col" class="etiology"><app-etiology class="content" /></div>
        </div>
    </nz-content>
</nz-layout>